/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Name_Cannot_Be_EmptyInputs */



/**
* | output |
* | --- |
* | "Project name cannot be empty" |
*
* @param {Projects_Name_Cannot_Be_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_name_cannot_be_empty = /** @type {((inputs?: Projects_Name_Cannot_Be_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Name_Cannot_Be_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektname kann nicht leer sein")
	return /** @type {LocalizedString} */ ("Project name cannot be empty")
});